module.exports = __webpack_public_path__ + "media/images/creator/home/icon-shop-bb786f974af0ddede9697b56829c2c91.svg";